import Swiper from 'swiper/bundle';
export function commonFunc() {
  var noticeSwiper, topOptions;
  noticeSwiper = undefined;
  topOptions = {
    freeMode: true,
    slidesPerView: 2.2,
    spaceBetween: 12,
    mousewheel: {
      forceToAxis: true,
      invert: false
    },
    navigation: {
      nextEl: '.corperate_news-prev',
      prevEl: '.corperate_news-next',
    },
    breakpoints: {
      768: {
        slidesPerView: 4.5,
        spaceBetween: 12
      }
    }
  };
  //スワイプ実行処理
  function initTopSwiper() {
    noticeSwiper = new Swiper('#noticeJs', topOptions);
  }
  initTopSwiper();
}